/** @format */

import React, { useState, useEffect } from "react";
import PhoneNumbersOverviewContainer from "./PhoneNumbersOverview.container";

const PhoneNumbersOverview: React.FC = () => {
	const [remountHelper, setRemountHelper] = useState<boolean>(false);

	useEffect(() => {
		setRemountHelper(false);
	}, [remountHelper]);

	return (
		<>
			{remountHelper ? (
				<div />
			) : (
				<PhoneNumbersOverviewContainer setRemountHelper={setRemountHelper} />
			)}
		</>
	);
};

export default PhoneNumbersOverview;
